module.exports = __webpack_public_path__ + "img/check.f084d334.svg";